import { observer } from 'mobx-react';
import React, { FC, ReactElement } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import CustomModalComponent from 'src/view/components/Controls/Modal/Modal';
import ModalBackground from 'src/view/components/Controls/Modal/ModalBackground/ModalBackground';
import { modalStore } from '~/mobx/modalStore';
import ModalFooter from '~/view/components/Controls/Modal/ModalFooter/ModalFooter';
import ModalHeader from '~/view/components/Controls/Modal/ModalHeader/ModalHeader';
import './style.scss';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import ModalContent from '~/view/components/Controls/Modal/ModalContent/ModalContent';
import { ButtonAppearance } from '~/view/components/Controls/ButtonComponent/types';

export const NoticeModal: FC = observer((): ReactElement => {
  const closeHandler = () => {
    modalStore.closeNoticeModal();
  };

  return (
    <CustomModalComponent isOpen={Boolean(modalStore.noticeModal)} onRequestClose={closeHandler} withCloseIcon className="notice-modal">
      <ModalBackground className="notice-modal__background">
        <ModalHeader
          title={localeStore.t(modalStore.noticeModal?.title ?? '')}
          wrapperClassName="notice-modal__header-wrapper"
          titleClassName="notice-modal__header"
        />
        <div className="notice-modal__content">{localeStore.t(modalStore.noticeModal?.message ?? '')}</div>
        <ModalFooter className="notice-modal__footer-wrapper">
          <Button className="notice-modal__button" onClick={closeHandler} appearance={ButtonAppearance.TERTIARY}>
            {localeStore.t(modalStore.noticeModal?.buttonText ?? '')}
          </Button>
        </ModalFooter>
      </ModalBackground>
    </CustomModalComponent>
  );
});
